import React from 'react';
import PropTypes from 'prop-types';
import SearchBarLayout from './SearchBarLayout.jsx';
import {getPassthroughProps} from '../componentHelpers.js';

/**
 * @deprecated Use SimpleSearchBar instead. Will be removed in v2.0.0
 */
class SearchBar extends React.Component {
  constructor(props) {
    super(props);

    this.submitTerm = this.submitTerm.bind(this);

    this.state = {
      isUserTyping: false,
      term: props.value,
    };

    console.warn("SearchBar has been deprecated. Please use SimpleSearchBar instead.");
  }

  get message() {
    if (this.props.noResults) {
      return this.props.noResultsMessage;
    }
    return '';
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.updateTerm({
        term: this.props.value,
      });
    }
  }

  updateTerm({ term, wasTypedByUser=false }) {
    let newState = {
      term: term,
    };
    if (wasTypedByUser) {
      newState.isUserTyping = true;
    }
    return new Promise(res => {
      this.setState(newState, res);
    });
  }

  submitTerm() {
    let {
      value,
      onChange
    } = this.props;
    let { term } = this.state;

    this.setState({ isUserTyping: false });

    if (value !== term) {
      onChange(term);
    }
  }

  render() {
    return (
      <SearchBarLayout {...getPassthroughProps(this)}
        value={this.state.term}
        message={this.state.isUserTyping ? '' : this.message}
        onKeyPress={e => {
          if (e.key === "Enter") {
            this.submitTerm();
          }
        }}
        onChange={x => this.updateTerm({
          term: x.target.value,
          wasTypedByUser: true
        })}
        onClear={() => {
          this.updateTerm({ term: '' })
            .then(() => this.submitTerm());
        }}
        submitTerm={this.submitTerm}
      />
    );
  }
}

SearchBar.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  noResults: PropTypes.bool,
  noResultsMessage: PropTypes.string,
};

SearchBar.defaultProps = {
  noResultsMessage: 'No results found for your search term. Try another.',
};

export default SearchBar;
